import { BankerEntity } from "domain/entity/Banker/BankerEntity";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import collectionAxiosInstance from "../axios/collectionAxiosInstance";
import { BankerRepository } from "./BankerRepo";

export const BankerRepoImpl = (): BankerRepository => {
    const url = '/v1/banker';

    const getEntities = async (): Promise<BankerEntity[]> => {
        return axiosGetData(collectionAxiosInstance, url, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onSave = async (entity: BankerEntity): Promise<ResponseEntity> => {
        return await axiosPostData(collectionAxiosInstance, `${url}`, entity);
    }


    return {
        onSave: onSave,
        getEntities: getEntities
    }
}